import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsUsersBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Users</div>
          <div className="text">
            Users can create posts, votes, and comments. Admins also have user accounts. The API
            allows you to fetch a specific user.
          </div>
        </div>
        <div></div>
      </APIDocsBlock>
    );
  }
}
